<template>
  <main
    id="js-page-content"
    role="main"
    class="page-content"
    :class="{
      isEdit: isEditMode,
    }"
  >
    <div class="row lockHeader shinseisyoHeader">
      <div class="subheader col-md-6">
        <h1 class="subheader-title">
          休暇届
          <sup
            v-if="delegate.request.c_request_status == 4"
            class="badge badge-dark fw-400 l-h-n"
            >取下</sup
          >
          <sup
            v-if="delegate.request.c_request_status == 1"
            class="badge badge-info fw-400 l-h-n"
            >申請中</sup
          >
          <sup
            v-if="delegate.request.c_request_status == 3"
            class="badge badge-success fw-400 l-h-n"
            >承認済</sup
          >
          <sup
            v-if="delegate.request.c_request_status == 2"
            class="badge badge-danger fw-400 l-h-n"
            >差戻</sup
          >
        </h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div
        class="subheader-block ml-auto demo col-md-6"
        style="text-align: right"
      >
        <button
          type="button"
          class="btn btn-primary waves-effect waves-themed"
          :disabled="btnDisable"
          v-if="delegate.request.c_request_status != 2 && isShowExportBtn()"
          @click="dl()"
        >
          <span class="fal fa-download mr-1"></span>Excel出力
        </button>
        <button
          type="button"
          v-if="!isEditMode"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
          @click="add()"
        >
          <span class="fal fa-check mr-1"></span>登録
        </button>
        <button
          type="button"
          v-if="
            isEditMode &&
            (isAdmin || isMine) &&
            delegate.request.c_request_status != 4
          "
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
          @click="disableConf()"
        >
          <span class="fal fa-check mr-1"></span>取下
        </button>
        <button
          type="button"
          v-if="isEditMode && isAdmin"
          :disabled="btnDisable"
          class="btn btn-danger waves-effect waves-themed"
          @click="delConf()"
        >
          <span class="fal fa-times mr-1"></span>削除
        </button>
        <button
          :disabled="btnDisable"
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          @click="$router.push('/shinseisyolist')"
        >
          <span class="fal fa-reply mr-1"></span>戻る
        </button>
      </div>
    </div>
    <div class="lockHeaderSpacer">　</div>
    <!-- Your main content goes below here: -->
    <!-- 承認処理待ちメッセージ -->
    <div class="alert alert-danger" v-if="fmShowConf">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">あなたが承認者です</span>
            <p>
              この申請書はあなたが承認者です。以下のボタンから承認か、差戻を選択できます。
            </p>
            <p class="m-0">
              <button
                type="button"
                class="btn btn-info waves-effect waves-themed"
                @click="upd4Approval(true)"
              >
                <span class="fal fa-check mr-1"></span>承認
              </button>
              <span style="width: 20px"> 　</span>
              <button
                type="button"
                class="btn btn-danger waves-effect waves-themed"
                @click="upd4Approval(false)"
              >
                <span class="fal fa-times mr-1"></span>差戻
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 承認処理待ちメッセージ -->
    <div class="alert alert-primary" v-if="fmShowConfEx">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">この申請書は承認依頼中です</span>
            <p>
              この申請書は承認依頼中です。お急ぎの場合は、承認者にご連絡ください。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 承認処理待ちメッセージ -->
    <!-- 差し戻しメッセージ -->
    <div class="alert alert-danger" v-if="fmShowSasimodosi">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">この申請書は差し戻しされました</span>
            <p>
              この申請書は承認権者により差し戻しされています。差し戻し理由を確認の上、再度新しく申請書を作成してください。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 差し戻しメッセージ -->
    <!-- 取り下げメッセージ -->
    <div class="alert alert-primary" v-if="fmShowTorisage">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i class="fal fa-info-circle"></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">この申請書は取り下げられました</span>
            <p>
              この申請書は申請者により取り下げられています。管理権限者はこの申請書を削除する事ができます。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 取り下げメッセージ -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>申請時用</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">申請番号</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtKouzaCd"
                        class="form-control form-control-sm"
                        v-model="delegate.request.c_request_id"
                        disabled
                      />
                    </div>
                    <div class="col-md-1 contTitle"></div>
                    <div class="col-md-5 contCnt"></div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">管理名</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        placeholder="xxxx案件でyyyy作業の為"
                        :disabled="isEditMode"
                        v-model="delegate.request.c_request_name"
                      />
                    </div>
                    <div class="col-md-1 contTitle"></div>
                    <div class="col-md-5 contCnt"></div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">申請日時</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtStartDate"
                        class="form-control form-control-sm"
                        maxlength="10"
                        v-bind:value="
                          convDateTime(delegate.request.c_request_datetime)
                        "
                        disabled
                      />
                    </div>
                    <div class="col-md-1 contTitle"></div>
                    <div class="col-md-5 contCnt"></div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">申請者</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <template v-if="isAdmin && !isEditMode">
                        <!-- 管理者用 入力モード用 -->
                        <vSelect
                          :options="getOpStaffs()"
                          label="c_staff_name"
                          v-model="delegate.request.c_staff_id"
                          :reduce="(label:any) => label.c_staff_id"
                        ></vSelect>
                      </template>
                      <template v-else>
                        <!-- 管理者以外用 -->
                        <input
                          type="text"
                          name="txtKouzaCd"
                          class="form-control form-control-sm"
                          disabled
                          v-model="domApplicantName"
                        />
                      </template>
                    </div>
                    <div class="col-md-1 contTitle"></div>
                    <div class="col-md-5 contCnt"></div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div
                class="row"
                style="
                  border-top: 1px solid #e5e5e5;
                  padding-top: 10px;
                  margin-bottom: 0;
                "
              >
                <div class="col-md-1 contTitle">期間</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md contCnt input-daterange input-group">
                      <div
                        class="input-daterange input-group"
                        id="datepicker-5"
                      >
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          name="start"
                          id="dateStart"
                          ref="dateStart"
                          :disabled="isEditMode"
                          v-model="domDateholiday_start"
                          @change="calculateDateDifference()"
                        />
                        <div class="input-group-append input-group-prepend">
                          <span class="input-group-text fs-xl">－</span>
                        </div>
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          name="end"
                          id="dateEnd"
                          ref="dateEnd"
                          :disabled="isEditMode"
                          v-model="domDateholiday_end"
                          @change="calculateDateDifference()"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="dateError">
                    <div
                      v-if="errors?.path === 'holiday_period'"
                      class="error-message4vali"
                    >
                      {{ errors.message }}
                    </div>
                    <div
                      v-if="errors?.path === 'startDate'"
                      class="error-message4vali"
                    >
                      {{ errors.message }}
                    </div>
                    <div
                      v-if="errors?.path === 'endDate'"
                      class="error-message4vali"
                    >
                      {{ errors.message }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5 contCnt input-group radiuszero">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        :disabled="isEditMode"
                        v-model="domholiday_days"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">日間</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    style="border-top: 1px solid #e5e5e5; padding-top: 10px"
                  >
                    <div class="col-md-5 contCnt">
                      <input
                        type="date"
                        class="form-control form-control-sm"
                        id="datePart"
                        ref="datePart"
                        :disabled="isEditMode"
                        v-model="domDateholiday_part"
                        @input="clearDate()"
                      />
                    </div>
                    <div class="col-md-5 contCnt">
                      <div
                        class="custom-control custom-radio custom-control-inline"
                      >
                        <input
                          type="radio"
                          id="rdGozen"
                          name="radioDaikyu"
                          class="custom-control-input"
                          value="1"
                          :disabled="isEditMode"
                          v-model="delegate.c_request_holiday_part_type"
                          @input="clearDate()"
                        /><label class="custom-control-label" for="rdGozen"
                          >午前休</label
                        >
                      </div>
                      <div
                        class="custom-control custom-radio custom-control-inline"
                      >
                        <input
                          type="radio"
                          id="rdGogo"
                          name="radioDaikyu"
                          class="custom-control-input"
                          value="2"
                          :disabled="isEditMode"
                          v-model="delegate.c_request_holiday_part_type"
                          @input="clearDate()"
                        /><label class="custom-control-label" for="rdGogo"
                          >午後休</label
                        >
                      </div>
                      <div class="partTypeError">
                        <div
                          v-if="errors?.path === 'partType'"
                          class="error-message4vali"
                        >
                          {{ errors.message }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">区分</div>
                <div class="col-md-5 contCnt mt-2">
                  <div class="row">
                    <div class="col-md-auto contCnt">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="rdYukyu"
                          name="radioGenre"
                          class="custom-control-input"
                          value="1"
                          :disabled="isEditMode"
                          v-model="delegate.c_request_holiday_type"
                        /><label class="custom-control-label" for="rdYukyu"
                          >有給休暇</label
                        >
                      </div>
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="rdSanzensango"
                          name="radioGenre"
                          class="custom-control-input"
                          value="2"
                          :disabled="isEditMode"
                          v-model="delegate.c_request_holiday_type"
                        /><label
                          class="custom-control-label"
                          for="rdSanzensango"
                          >産前産後休暇</label
                        >
                      </div>
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="rdKaki"
                          name="radioGenre"
                          class="custom-control-input"
                          value="3"
                          :disabled="isEditMode"
                          v-model="delegate.c_request_holiday_type"
                        /><label class="custom-control-label" for="rdKaki"
                          >夏期休暇</label
                        >
                      </div>
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="rdDaikyu"
                          name="radioGenre"
                          class="custom-control-input"
                          value="4"
                          :disabled="isEditMode"
                          v-model="delegate.c_request_holiday_type"
                        /><label class="custom-control-label" for="rdDaikyu"
                          >代休・振替</label
                        >
                      </div>
                    </div>
                    <!-------------------->
                    <div class="col-md-auto contCnt">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="rdSeiri"
                          name="radioGenre"
                          class="custom-control-input"
                          value="5"
                          :disabled="isEditMode"
                          v-model="delegate.c_request_holiday_type"
                        /><label class="custom-control-label" for="rdSeiri"
                          >生理休暇</label
                        >
                      </div>
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="rdTenkin"
                          name="radioGenre"
                          class="custom-control-input"
                          value="6"
                          :disabled="isEditMode"
                          v-model="delegate.c_request_holiday_type"
                        /><label class="custom-control-label" for="rdTenkin"
                          >転勤休暇</label
                        >
                      </div>
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="rdKeiji"
                          name="radioGenre"
                          class="custom-control-input"
                          value="7"
                          :disabled="isEditMode"
                          v-model="delegate.c_request_holiday_type"
                        /><label class="custom-control-label" for="rdKeiji"
                          >慶事休暇</label
                        >
                      </div>
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="rdTokubetsu"
                          name="radioGenre"
                          class="custom-control-input"
                          value="8"
                          :disabled="isEditMode"
                          v-model="delegate.c_request_holiday_type"
                        /><label class="custom-control-label" for="rdTokubetsu"
                          >特別休暇</label
                        >
                      </div>
                    </div>
                    <!-------------------->
                    <div class="col-md-auto contCnt">
                      <div
                        class="custom-control custom-radio custom-control-inline mb-3"
                      >
                        <input
                          type="radio"
                          id="rdSonota"
                          name="radioGenre"
                          class="custom-control-input"
                          value="9"
                          :disabled="isEditMode"
                          v-model="delegate.c_request_holiday_type"
                        /><label
                          class="custom-control-label mr-3"
                          for="rdSonota"
                          >その他</label
                        >
                        <input
                          type="text"
                          class="col form-control form-control-sm"
                          :disabled="isEditMode"
                          v-model="domHoliday_type_oth"
                        />
                      </div>
                      <div class="holidayTypeError">
                        <div
                          v-if="errors?.path === 'holidayType'"
                          class="error-message4vali"
                        >
                          {{ errors.message }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">事由</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md contCnt">
                      <textarea
                        class="form-control"
                        rows="5"
                        style="margin-bottom: 5px"
                        :disabled="isEditMode"
                        v-model="domReason"
                      >
                      </textarea>
                      <div
                        v-if="errors?.path === 'holiday_cont'"
                        class="error-message4vali"
                      >
                        {{ errors.message }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">備考</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md contCnt">
                      <textarea
                        class="form-control"
                        rows="5"
                        style="margin-bottom: 5px"
                        :disabled="isEditMode"
                        v-model="domRemarks"
                      >
                      </textarea>
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">第一承認</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtKouzaNumber"
                        class="form-control form-control-sm"
                        maxlength="10"
                        v-bind:value="getAuthoriser(1)"
                        disabled
                      />
                    </div>

                    <div class="col-md-2 contTitle">承認日時</div>
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtStartDate"
                        class="form-control form-control-sm"
                        v-bind:value="
                          getAuthDate(
                            delegate.request.c_request_1_approval,
                            delegate.request.c_request_1_approval_datetime
                          )
                        "
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">第二承認</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtKouzaNumber"
                        class="form-control form-control-sm"
                        maxlength="10"
                        v-bind:value="getAuthoriser(2)"
                        disabled
                      />
                    </div>

                    <div class="col-md-2 contTitle">承認日時</div>
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtStartDate"
                        class="form-control form-control-sm"
                        v-bind:value="
                          getAuthDate(
                            delegate.request.c_request_2_approval,
                            delegate.request.c_request_2_approval_datetime
                          )
                        "
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">最終承認</div>
                <div class="col-md-5 contCnt">
                  <div class="row">
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtKouzaNumber"
                        class="form-control form-control-sm"
                        maxlength="10"
                        v-bind:value="getAuthoriser(3)"
                        disabled
                      />
                    </div>

                    <div class="col-md-2 contTitle">承認日時</div>
                    <div class="col-md-5 contCnt">
                      <input
                        type="text"
                        name="txtStartDate"
                        class="form-control form-control-sm"
                        v-bind:value="
                          getAuthDate(
                            delegate.request.c_request_3_approval,
                            delegate.request.c_request_3_approval_datetime
                          )
                        "
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!-------------------->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 成功通知モーダル -->
    <Mo_modal_alert ref="Mo_modal_success" @modalclosed="get()">
      <template v-slot:title>
        <i class="fal fa-check-circle text-success mr-2"></i>
        <span class="text-success fw-500">{{ message4ModalSuccess }}</span>
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer"><br /></div>
      </template>
    </Mo_modal_alert>
    <!-- 成功通知モーダル -->
    <!-- 削除確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_deleteConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalDelConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="del()"
            type="button"
            class="btn btn-danger shadow-0 bootbox-accept"
          >
            はい</button
          ><button
            @click="closeModal4deleteConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            いいえ
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- 削除確認モーダル -->
    <!-- 取下確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_disableConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalDisableConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="disab()"
            type="button"
            class="btn btn-danger shadow-0 bootbox-accept"
          >
            はい</button
          ><button
            @click="closeModal4disableConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            いいえ
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- 取下確認モーダル -->
    <!-- エラー確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_errorConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalErrorConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="closeModal4ErrorConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            確認
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Cl_common } from "@/functions/Cl_common";
import { DtoRequestHolidaysGetReqImple } from "furukawa-common/src/common/dto/DtoRequestHolidaysGetReqImple";
import { DtoRequestHolidaysGetResImple } from "furukawa-common/src/common/dto/DtoRequestHolidaysGetResImple";
import { DtoRequestHolidaysPostReqImple } from "furukawa-common/src/common/dto/DtoRequestHolidaysPostReqImple";
import { DtoBanksPutReq } from "furukawa-common/src/common/dto/abst/DtoBanksPutReq";
import { DtoBanksPutRes } from "furukawa-common/src/common/dto/abst/DtoBanksPutRes";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";
import { DtoBanksPostReq } from "furukawa-common/src/common/dto/abst/DtoBanksPostReq";
import { Cl_bank } from "@/functions/Cl_bank";
import store from "@/store";
import { CommonStaff } from "furukawa-common/src/common/service/CommonStaff";
import { Cl_requestholiday } from "@/functions/Cl_requestholiday";
import {
  CONST_APPROVAL_STATUS_SYOUNIN,
  CONST_REQUEST_STATUS_SASIMODOSI,
  CONST_REQUEST_STATUS_SINSEITYU,
  CONST_REQUEST_STATUS_SYOUNINZUMI,
  CONST_REQUEST_STATUS_TORISAGE,
} from "furukawa-common/src/common/constant/Constants";
import { DtoRequestsPutReqImple } from "furukawa-common/src/common/dto/DtoRequestsPutReqImple";
import { Cl_request } from "@/functions/Cl_request";
// バリデーション
import * as Yup from "yup";
// masters
import { Cl_master } from "@/functions/Cl_master";
import { DtoMastersgetReq } from "furukawa-common/src/common/dto/DtoMastersGetReq";
import { DtoMastersGetRes } from "furukawa-common/src/common/dto/DtoMastersGetRes";
import { Cl_filemaster } from "@/functions/Cl_filemaster";
import { DtoFileMastersGetReqImple } from "furukawa-common/src/common/dto/DtoFileMastersGetReqImple";
import { EntityStaff } from "../../../furukawa-common/src/common/entity/EntityStaff";

@Options({
  components: {
    vSelect,
    Mo_modal_alert,
  },
})
export default class shinsei_Kyukatodokeedit extends Vue {
  //----------------------
  //バリデーション
  //----------------------
  //スキーマ宣言
  schemaAdd = Yup.object().shape({
    holiday_type: Yup.string().required("区分を入力してください"),
    holiday_cont: Yup.string().required("事由を入力してください"),
  });

  schemaAddDate = Yup.object().shape({
    holiday_period: Yup.string().required("期間を入力してください"),
  });

  schemaAddDateStart = Yup.object().shape({
    startDate: Yup.string().required("開始日を入力してください"),
  });

  schemaAddDateEnd = Yup.object().shape({
    endDate: Yup.string().required("終了日を入力してください"),
  });

  schemaAddPartType = Yup.object().shape({
    partType: Yup.string().required("午前か午後を選択してください"),
  });

  schemaAddHolidayType = Yup.object().shape({
    holidayType: Yup.string().required("その他の内容を入力してください"),
  });

  //エラー格納用
  errors: Yup.ValidationError | null = null;
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  delegate = new DtoRequestHolidaysGetResImple();
  delegate4list = new DtoMastersGetRes();
  btnDisable = false;
  isEditMode = true;
  isAdmin = false;
  isMine = false;

  domApplicantName = "";
  domContent = "";
  domReason = "";
  domRemarks = "";
  domHoliday_type_oth = "";

  dateStartInput = "";
  dateEndInput = "";
  datePartInput = "";
  dateDoubleInput = "";

  //日付関係
  domDateholiday_start: string | undefined = ""; //delegate.c_request_holiday_start
  domDateholiday_end: string | undefined = ""; //delegate.c_request_holiday_end
  domDateholiday_part: string | undefined = ""; //delegate.c_request_holiday_part
  domholiday_days: string | undefined = "";

  //承認フォームの表示非表示フラグ
  fmShowConf = false;
  fmShowConfEx = false;
  fmShowSasimodosi = false;
  fmShowTorisage = false;

  //----------------------
  //DOM連携用メソッド
  //----------------------
  convDateTime(val: Date | null): string {
    let res = "";

    if (val == null) {
      res = "";
    } else {
      res = val
        .toString()
        .replaceAll("-", "/")
        .replace("T", " ")
        .replace(".000Z", "");
    }

    return res;
  }

  /**
   * 承認者の順序を入力して、承認者名を得る
   * @param num
   */
  getAuthoriser(num: number): string {
    let res = "-";

    if (this.delegate4list.items4staffs == null) {
      return "-";
    }

    switch (num) {
      case 1:
        if (this.delegate.request.c_request_1_approval == null) {
          res = "-";
        } else {
          res = CommonStaff.cnvStaffNum2Name(
            this.delegate4list.items4staffs,
            this.delegate.request.c_request_1_approval
          );
        }

        break;
      case 2:
        if (this.delegate.request.c_request_2_approval == null) {
          res = "-";
        } else {
          res = CommonStaff.cnvStaffNum2Name(
            this.delegate4list.items4staffs,
            this.delegate.request.c_request_2_approval
          );
        }

        break;
      case 3:
        if (this.delegate.request.c_request_3_approval == null) {
          res = "-";
        } else {
          res = CommonStaff.cnvStaffNum2Name(
            this.delegate4list.items4staffs,
            this.delegate.request.c_request_3_approval
          );
        }

        break;
      default:
        break;
    }

    return res;
  }

  /**
   * 承認日時を受け取り、表示用の文字列にして返す
   * @param val
   */
  getAuthDate(authorizerId: number | null, val: Date | null): string {
    let res = "";

    if (authorizerId == null) {
      return "-";
    }

    if (val == null) {
      res = "未承認";
    } else {
      res = val
        .toString()
        .replaceAll("-", "/")
        .replace("T", " ")
        .replace(".000Z", "");
    }

    return res;
  }

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  /**
   * 社員の選択肢を構築する用
   */
  getOpStaffs(): EntityStaff[] {
    return this.delegate4list.getStaffSortNum4NoneDelete([
      this.delegate.request.c_staff_id!,
    ]);
  }
  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalSuccess = "";
  message4ModalDelConf = "";
  message4ModalDisableConf = "";
  message4ModalErrorConf = "";

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    await this.getMastersList();
    await this.get();
  }
  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   *Masters取得用
   */
  async getMastersList() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行社員マスタ取得");

      //準備
      //-------
      let dtoMaster = new DtoMastersgetReq();

      dtoMaster.getStaff4sortNum = 1;
      dtoMaster.delFlag4Staff4sortNum = 1;
      dtoMaster.getStaff = 1;
      dtoMaster.delFlag4staff = 0;

      //API実行
      //-------
      this.delegate4list = await Cl_master.get(dtoMaster);

      //レスポンス処理
      //-------
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      this.delegate4list = new DtoMastersGetRes();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  async get() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //パラメータにIDが指定されていなければ、新規追加モードでデータを読み込まない
      //-------
      let id = Cl_common.getParam("id");
      store.commit("revStore");
      const authType = store.state.authType;
      // Cl_common.logger(authType);
      this.isAdmin = authType == 4; //管理者判定

      if (id == "") {
        //新規追加
        this.isEditMode = false;
        //初期値設定
        this.delegate.request.c_staff_id = store.state.id;
        // this.delegate.c_request_holiday_part_type = 1;
        this.fmShowConf = false;
        this.fmShowConfEx = false;
        return;
      } else {
        //編集
        this.isEditMode = true;
      }

      //準備
      //-------
      let dto = new DtoRequestHolidaysGetReqImple();

      //※fanctions内のクラスの修正コスト軽減の為、c_request_holiday_idに入れているが、
      //  API側ではrequestIDとして扱われるので注意
      dto.c_request_holiday_id = Number(id);

      //API実行
      //-------
      this.delegate = await Cl_requestholiday.get(dto);
      Cl_common.logger("delegate");
      Cl_common.logger(this.delegate);

      //レスポンス処理
      //-------
      //IDがnullなら一覧へ遷移
      if (this.delegate.c_request_holiday_id == null) {
        this.$router.push("/shinseisyolist");
      }

      //UI連携用変数に入力
      //---
      await this.cnvData4Get();

      //フラグ更新
      //---
      store.commit("revStore");
      const loginStaffId = store.state.id;
      this.isMine = loginStaffId == this.delegate.request.c_staff_id!; //申請者判定

      //承認関係の表記
      //---
      await this.chgAuthCont();

      //何日間かの計算
      await this.calculateDateDifference();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * DOM連携用の変換処理　GET用。
   */
  async cnvData4Get() {
    //申請者
    this.domApplicantName = CommonStaff.cnvStaffNum2Name(
      this.delegate4list.items4staffs,
      this.delegate.request.c_staff_id
    );

    //期間
    if (this.delegate.c_request_holiday_start != null) {
      this.domDateholiday_start = this.delegate
        .c_request_holiday_start!.toString()
        .split("T")[0];
    }
    if (this.delegate.c_request_holiday_end != null) {
      this.domDateholiday_end = this.delegate
        .c_request_holiday_end!.toString()
        .split("T")[0];
      Cl_common.logger("this.domDateholiday_end");
      Cl_common.logger(this.domDateholiday_end);
    }

    //部分休暇
    Cl_common.logger("部分休暇");
    Cl_common.logger(this.delegate.c_request_holiday_part);
    if (this.delegate.c_request_holiday_part != null) {
      Cl_common.logger("部分休暇if内");
      this.domDateholiday_part = this.delegate
        .c_request_holiday_part!.toString()
        .split("T")[0];
      Cl_common.logger("this.domDateholiday_part");
      Cl_common.logger(this.domDateholiday_part);
    }

    //その他
    if (this.delegate.c_request_holiday_type_oth != null) {
      this.domHoliday_type_oth = this.delegate.c_request_holiday_type_oth;
    }

    //事由
    if (this.delegate.c_request_holiday_cont != null) {
      this.domReason = this.delegate.c_request_holiday_cont;
    }
    //備考
    if (this.delegate.c_request_holiday_remarks != null) {
      this.domRemarks = this.delegate.c_request_holiday_remarks;
    }
  }

  /**
   * 承認に関するコンテンツを制御する
   */
  async chgAuthCont() {
    let loginStaffId = -1;

    switch (this.delegate.request.c_request_status) {
      case CONST_REQUEST_STATUS_SINSEITYU:
        //申請中
        //-----------
        store.commit("revStore");
        loginStaffId = store.state.id;
        if (
          (loginStaffId == this.delegate.request.c_request_1_approval &&
            this.delegate.request.c_request_1_approval_datetime == null) ||
          (loginStaffId == this.delegate.request.c_request_2_approval &&
            this.delegate.request.c_request_2_approval_datetime == null) ||
          (loginStaffId == this.delegate.request.c_request_3_approval &&
            this.delegate.request.c_request_3_approval_datetime == null)
        ) {
          //自身が承認者で未承認
          //--------
          this.fmShowConf = true;
          this.fmShowConfEx = false;
          this.fmShowSasimodosi = false;
          this.fmShowTorisage = false;
        } else {
          //自身が承認者でない、もしくは承認済み
          //--------
          this.fmShowConf = false;
          this.fmShowConfEx = true;
          this.fmShowSasimodosi = false;
          this.fmShowTorisage = false;
        }

        break;
      case CONST_REQUEST_STATUS_SASIMODOSI:
        //差戻
        //-----------
        this.fmShowConf = false;
        this.fmShowConfEx = false;
        this.fmShowSasimodosi = true;
        this.fmShowTorisage = false;
        break;
      case CONST_REQUEST_STATUS_SYOUNINZUMI:
        //承認済
        //-----------
        this.fmShowConf = false;
        this.fmShowConfEx = false;
        this.fmShowSasimodosi = false;
        this.fmShowTorisage = false;
        break;
      case CONST_REQUEST_STATUS_TORISAGE:
        //取下
        //-----------
        this.fmShowConf = false;
        this.fmShowConfEx = false;
        this.fmShowSasimodosi = false;
        this.fmShowTorisage = true;

        break;
      default:
        throw new Error("不正なstatus");
    }
  }

  /**
   * データを更新する
   */
  async upd(isDel: boolean, isDisable: boolean) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoRequestsPutReqImple();
      let id = Cl_common.getParam("id");
      dto.c_request_id = Number(id);
      if (isDel) {
        //削除処理：削除フラグを立てる。
        dto.c_request_flag_del = 1;
      } else {
        //差戻処理：ステータス変更。
        dto.c_request_status = 4;
      }

      //API実行
      //-------
      await Cl_request.put(dto);
      //レスポンスの処理
      //-------

      //更新処理：
      //モーダルのメッセージを設定
      if (isDel) {
        //削除処理：
        this.message4ModalSuccess = "正常に削除されました";
      } else {
        //更新処理：
        this.message4ModalSuccess = "正常に変更されました";
      }

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * データを更新する
   * 承認・差戻用
   */
  async upd4Approval(isApproval: boolean) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      // //準備
      // //-------
      let dto = new DtoRequestsPutReqImple();
      let id = Cl_common.getParam("id");
      dto.c_request_id = Number(id);

      if (isApproval) {
        //承認
        dto.isApproval = 1;
      } else {
        //差戻
        dto.isApproval = 0;
      }

      //API実行
      //-------
      await Cl_request.put(dto);
      //レスポンスの処理
      //-------

      //更新処理：
      //モーダルのメッセージを設定
      if (isApproval) {
        //削除処理：
        this.message4ModalSuccess = "正常に承認されました";
      } else {
        //更新処理：
        this.message4ModalSuccess = "正常に差戻されました";
      }

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * データを新たに登録する
   */
  async add() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //バリデーション
      //-----------------
      //期間と半休どちらも選択されていない
      this.errors = null;
      if (
        !this.domDateholiday_start &&
        !this.domDateholiday_end &&
        !this.domDateholiday_part
      ) {
        this.dateDoubleInput = "";

        this.schemaAddDate.validateSync({
          holiday_period: this.dateDoubleInput,
        });
      }

      //期間（開始か終了が選択されている）
      if (
        (this.domDateholiday_start || this.domDateholiday_end) &&
        !this.domDateholiday_part
      ) {
        //開始か選択されていない）
        if (!this.domDateholiday_start) {
          this.schemaAddDateStart.validateSync({
            startDate: this.domDateholiday_start,
          });
        }

        //終了か選択されていない）
        if (!this.domDateholiday_end) {
          this.schemaAddDateEnd.validateSync({
            endtDate: this.domDateholiday_end,
          });
        }
      }

      //半休が選択されている
      if (
        !this.domDateholiday_start &&
        !this.domDateholiday_end &&
        this.domDateholiday_part
      ) {
        if (!this.domDateholiday_start) {
          this.schemaAddPartType.validateSync({
            partType: this.delegate.c_request_holiday_part_type,
          });
        }
      }

      this.schemaAdd.validateSync({
        holiday_type: this.delegate.c_request_holiday_type,
        holiday_cont: this.domReason,
      });

      if (this.delegate.c_request_holiday_type == 9) {
        this.schemaAddHolidayType.validateSync({
          holidayType: this.domHoliday_type_oth,
        });
      }

      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      //-------
      //UI連携用変数からdelegateに戻す
      //---
      await this.cnvData4Add();

      let dto = Object.assign(
        new DtoRequestHolidaysPostReqImple(),
        this.delegate
      );

      //API実行
      //-------
      const res = await Cl_requestholiday.post(dto);

      //レスポンスの処理
      //-------
      //編集画面のURL作成
      this.$router.push({
        path: "/shinsei_Kyukatodokeedit",
        query: { id: res.c_request_id },
      });

      //モーダルのメッセージを設定
      this.message4ModalSuccess = "正常に追加されました";

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * DOM連携用の変換処理　ADD用。
   */
  async cnvData4Add() {
    //期間
    if (this.domDateholiday_start != undefined) {
      this.delegate.c_request_holiday_start = new Date(
        this.domDateholiday_start
      );
    }
    if (this.domDateholiday_end != undefined) {
      this.delegate.c_request_holiday_end = new Date(this.domDateholiday_end);
    }

    //部分休暇
    if (this.domDateholiday_part != undefined) {
      this.delegate.c_request_holiday_part = new Date(this.domDateholiday_part);
    }

    //その他
    if (this.domHoliday_type_oth != null) {
      this.delegate.c_request_holiday_type_oth = this.domHoliday_type_oth;
    }

    //事由
    if (this.domReason != null) {
      this.delegate.c_request_holiday_cont = this.domReason;
    }

    //備考
    if (this.domRemarks != null) {
      this.delegate.c_request_holiday_remarks = this.domRemarks;
    }
  }

  /**
   * ファイルをダウンロードする
   */
  async dl() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoFileMastersGetReqImple();
      dto.type = "Kyukatodoke";
      let id = Cl_common.getParam("id");
      dto.requestId = Number(id);
      //API実行
      //-------
      const res = await Cl_filemaster.get(dto);

      //レスポンス処理
      //-------
      location.href = res.url;
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * データ削除用のモーダルを表示
   */
  async delConf() {
    //モーダルのメッセージを設定
    this.message4ModalDelConf =
      "【" +
      this.delegate.c_request_id +
      "】" +
      this.delegate.request.c_request_name +
      "を削除します。よろしいですか？";
    //モーダル表示
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.showModal();
  }
  /**
   * 取り下げ用のモーダルを表示
   */
  async disableConf() {
    //モーダルのメッセージを設定
    this.message4ModalDisableConf =
      "【" +
      this.delegate.c_request_id +
      "】" +
      this.delegate.request.c_request_name +
      "を取り下げます。よろしいですか？";
    //モーダル表示
    const modal: any = this.$refs.Mo_modal_disableConf;
    modal.showModal();
  }
  /**
   * データを削除する
   */
  async del() {
    //削除フラグのあるテーブルなので更新処理。
    this.closeModal4deleteConf();
    this.upd(true, false);
  }
  /**
   * データを取り下げる
   */
  async disab() {
    //削除フラグのあるテーブルなので更新処理。
    this.closeModal4disableConf();
    this.upd(false, true);
  }
  //----------------------
  //日にち計算用
  //----------------------
  async calculateDateDifference() {
    let diffDays = 0;

    if (this.domDateholiday_start || this.domDateholiday_end) {
      //半休をクリア
      this.domDateholiday_part = "";
      const radio1 = document.getElementById("rdGozen");
      const radio2 = document.getElementById("rdGogo");
      (radio1 as HTMLInputElement).checked = false;
      (radio2 as HTMLInputElement).checked = false;
    }

    if (this.domDateholiday_start && this.domDateholiday_end) {
      const date1 = new Date(this.domDateholiday_start);
      const date2 = new Date(this.domDateholiday_end);

      const diffTime = Math.abs(date2.getTime() - date1.getTime());
      diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffTime === 0) {
        diffDays = 1; // 日付が同じ場合、結果を1日とする
      } else if (date2 > date1) {
        diffDays++; // 日付が翌日の場合、結果を2日とする
      }
    } else {
      diffDays = 0;
    }

    this.domholiday_days = String(diffDays);
  }

  async clearDate() {
    this.domDateholiday_start = "";
    this.domDateholiday_end = "";
    this.domholiday_days = "";
  }
  /**
   * エクセル出力ボタンの表示・非表示を制御する。
   */
  isShowExportBtn() {
    if (!this.isEditMode) {
      return false;
    }

    //データがなければ非表示
    if (this.delegate == null || this.delegate.c_request_id == null) {
      return false;
    }

    //差戻かつ本人でない場合、非表示
    store.commit("revStore");
    const loginStaffId = store.state.id;
    if (
      this.delegate.request.c_request_status ==
        CONST_REQUEST_STATUS_SASIMODOSI &&
      this.delegate.request.c_staff_id != loginStaffId
    ) {
      return false;
    }

    //承認済みステータスであれば表示
    if (
      this.delegate.request.c_request_status == CONST_REQUEST_STATUS_SYOUNINZUMI
    ) {
      return true;
    }

    //一人でも承認して入れば表示
    if (
      this.delegate.request.c_request_1_approval_status ==
        CONST_APPROVAL_STATUS_SYOUNIN ||
      this.delegate.request.c_request_2_approval_status ==
        CONST_APPROVAL_STATUS_SYOUNIN ||
      this.delegate.request.c_request_3_approval_status ==
        CONST_APPROVAL_STATUS_SYOUNIN
    ) {
      return true;
    }

    // それ以外は非表示
    return false;
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal4deleteConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.closeModal();
  }

  async closeModal4disableConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_disableConf;
    modal.closeModal();
  }

  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
}
</script>

<style scoped>
.titleMargin {
  margin: 15px 5px;
}

.titleKubetsu {
  border-radius: 0%;
  padding: 0.5rem;
}
.input-group-text {
  height: 30px;
  padding: 5px;
}

.notActive {
  background-color: rgb(229, 229, 229);
}
.notActive input {
  background-color: rgb(229, 229, 229) !important;
}

.isEdit input:disabled,
.isEdit textarea:disabled {
  background-color: #fff;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
}

.dateError {
  text-align: center;
  margin-bottom: 8px;
}

.partTypeError {
  text-align: left;
  margin-bottom: 8px;
}
</style>
